import { createColumnHelper } from 'src/lib/tanstack-react-table';
import { TextCell } from 'src/components/Table/Cells';
import { SIM_CARD_DETAIL_SCHEMA } from 'src/utils/api/get-sim-card-details';
import { SimHealthCell, SimLastSeenCell, SimMapCell, SimUsageCell } from './SimCells';

const columnHelper = createColumnHelper<SIM_CARD_DETAIL_SCHEMA>();

export const TABLE_COLUMNS = [
  columnHelper.accessor((row) => row.sim_id, {
    header: 'sim.table.sim.id',
    cell: TextCell,
  }),
  columnHelper.display({
    id: 'health',
    header: 'sim.table.health',
    cell: SimHealthCell,
  }),
  columnHelper.accessor((row) => row.rate_plan || '', {
    header: 'sim.table.plan',
    cell: TextCell,
  }),
  columnHelper.accessor((row) => row.data_usage, {
    header: 'sim.table.usage',
    cell: SimUsageCell,
  }),
  columnHelper.display({
    id: 'last_seen',
    header: 'sim.table.last.seen',
    cell: SimLastSeenCell,
  }),
  columnHelper.display({
    id: 'map',
    header: 'sim.table.location',
    cell: SimMapCell,
  }),
];
